export default {
	SIMILAR: 'SIMILAR',
	SIMILAR_ROS: 'SIMILAR_ROS',
	BOW: 'BOW',
	PAIVER: 'PAIVER',
	PAIVER_ROS: 'PAIVER_ROS',
	PVREC_CROSS_CAT: 'PVREC_CROSS_CAT',
	PVREC_CROSS_CAT_ROS: 'PVREC_CROSS_CAT_ROS',
	SIMILAR_VENDORS_BASED_ON_ACTIVITY: 'SIMILAR_VENDORS_BASED_ON_ACTIVITY',
} as const;
